import {Routes} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';

const adminActions = [
  {label: 'Avocats', routerLink: '/admin/avocats'},
  {label: 'Prospects', routerLink: '/admin/prospects'},
  {label: 'Formulaires prospects', routerLink: '/admin/formulaires-prospects'},
  {label: 'Offres', routerLink: '/admin/offres'},
  {label: 'Options de quota', routerLink: '/admin/option-quotas'},
  {label: "CGUs", routerLink: '/admin/cgus'},
  {label: "CGVs", routerLink: '/admin/cgvs'},
  {label: 'Clients', routerLink: '/admin/clients'},
  {label: 'Formulaires paiement', routerLink: '/admin/formulaires-methode-paiement'},
  {label: 'Formulaires onboarding', routerLink: '/admin/formulaires-onboarding'},
  {label: 'Contrats', routerLink: '/admin/contrats'},
  {label: 'Factures', routerLink: '/admin/factures'},
  {label: 'Avoirs', routerLink: '/admin/avoirs'},
  {label: 'Transactions', routerLink: '/admin/transactions'},
  {label: 'Utilisateurs', routerLink: '/admin/utilisateurs'},
  {label: 'Workflows email', routerLink: '/admin/workflows-email'},
  {label: 'Templates email', routerLink: '/admin/templates-email'},
  {label: "Articles", routerLink: '/admin/articles'},
  {label: "Topics", routerLink: '/admin/topics'},
  {label: "Auteurs", routerLink: '/admin/auteurs'},
  {label: 'Fonctionnalités', routerLink: '/admin/fonctionnalites'},
  {label: 'Rôles', routerLink: '/admin/roles'},
  {label: 'Spécialités juridiques', routerLink: '/admin/specialites-juridiques'},
  {label: 'Statuts prospects', routerLink: '/admin/statuts-prospect'},
  {label: "Types d'interaction prospect", routerLink: '/admin/types-interaction-prospect'},
  {label: "Types d'interaction client", routerLink: '/admin/types-interaction-client'},
  {label: 'Paramètres', routerLink: '/admin/parametres'},
];

const adminOffersActions = [
  {label: 'Nouvelle offre', routerLink: '/admin/offres/edition'},
];

const adminInvoicesActions = [
  {label: 'Nouvelle facture', routerLink: '/admin/factures/edition'},
];

const adminCreditsActions = [
  {label: 'Nouvel avoir', routerLink: '/admin/avoirs/edition'},
];

const adminLawFirmUsersActions = [
  {label: 'Nouvel utilisateur', routerLink: '/admin/utilisateurs/edition'},
];

const adminVehiclesActions = [
  {label: 'Nouveau véhicule', routerLink: '/admin/vehicules/edition'},
];

const adminContractActions = [
  {label: 'Nouveau contrat', routerLink: '/admin/contrats/edition'},
];

const adminEmailTemplatesActions = [
  {label: 'Nouveau template email', routerLink: '/admin/templates-email/edition'},
];

const adminEmailWorkflowsActions = [
  {label: 'Nouveau workflow email', routerLink: '/admin/workflows-email/edition'},
];

const adminFeaturesActions = [
  {
    label: 'Nouvelle fonctionnalité',
    routerLink: '/admin/fonctionnalites/edition',
  },
];

const adminGeneralConditionsOfSalesActions = [
  {
    label: 'Nouvelles CGV',
    routerLink: '/admin/cgvs/edition',
  },
];

const adminGeneralConditionsOfUsesActions = [
  {
    label: 'Nouvelles CGU',
    routerLink: '/admin/cgus/edition',
  },
];

const adminRolesActions = [
  {label: 'Nouveau Rôle', routerLink: '/admin/roles/edition'},
];

const adminLegalPracticeAreaActions = [
  {label: 'Nouvelle spcécialité juridique', routerLink: '/admin/specialites-juridiques/edition'},
];

const adminLegalTopicActions = [
  {label: 'Nouvelle thématique juridique', routerLink: '/admin/thematiques-juridiques/edition'},
];

const adminCaseTypeActions = [
  {label: 'Nouveau type d\'affaire', routerLink: '/admin/types-d-affaire/edition'},
];

const adminCourtLevelsActions = [
  {label: 'Nouvelle instance', routerLink: '/admin/instances/edition'},
];

const adminEngagementTypesActions = [
  {label: 'Nouveau type de mission', routerLink: '/admin/types-de-mission/edition'},
];

const adminProceedingTypesActions = [
  {label: 'Nouveau type de procédure', routerLink: '/admin/types-de-procedure/edition'},
];

const adminCaseOwnerTypesActions = [
  {label: 'Nouveau type de responsable dossier', routerLink: '/admin/types-de-responsable-dossier/edition'},
];

const adminAttorneyInChargeTypesActions = [
  {label: 'Nouveau type d\'avocat en charge', routerLink: '/admin/types-d-avocat-en-charge/edition'},
];

const adminDocumentListUsagesActions = [
  {label: 'Nouvelle utilisation liste documents', routerLink: '/admin/utilisations-liste-documents/edition'},
];

const adminDocumentNameTypesActions = [
  {label: 'Nouveau nommage de document', routerLink: '/admin/nommages-documents/edition'},
];

const adminTimeTrackingTypeActions = [
  {label: 'Nouveau type de suivi de temps', routerLink: '/admin/types-de-suivi-de-temps/edition'},
];

const adminQuotaOptionsActions = [
  {label: 'Nouvelle option de quota', routerLink: '/admin/option-quotas/edition'},
];

const adminProspectStatusesActions = [
  {
    label: 'Nouveau statut prospect',
    routerLink: '/admin/statuts-prospect/edition',
  },
];

const adminTopicsActions = [
  {label: 'Nouveau topic', routerLink: '/admin/topics/edition'},
];

const adminAuthorsActions = [
  {label: 'Nouvel auteur', routerLink: '/admin/auteurs/edition'},
];

const adminArticlesActions = [
  {label: 'Nouvel article', routerLink: '/admin/articles/edition'},
];

const adminInteractionProspectTypesActions = [
  {
    label: "Nouveau type d'interaction prospect",
    routerLink: '/admin/types-interaction-prospect/edition',
  },
];

const adminInteractionLawFirmTypesActions = [
  {
    label: "Nouveau type d'interaction client",
    routerLink: '/admin/types-interaction-client/edition',
  },
];

const adminSettingsActions = [
  {label: 'Nouveau paramètre', routerLink: '/admin/parametres/edition'},
];

const adminLawFirmActions = [
  {label: 'Utilisateurs', routerLink: '/admin/clients/edition/#id#/utilisateurs'},
  {label: 'Contrats', routerLink: '/admin/clients/edition/#id#/contrats'},
  {label: 'Factures', routerLink: '/admin/clients/edition/#id#/factures'},
  {label: 'Transactions', routerLink: '/admin/clients/edition/#id#/transactions'},
  {label: 'Formulaires paiement', routerLink: '/admin/clients/edition/#id#/formulaires-methode-paiement'},
  {label: 'Formulaires changement d\'offre', routerLink: '/admin/clients/edition/#id#/formulaires-changement-offre'},
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },

  {
    path: 'formulaire-d-inscription/:id/:bearer',
    loadChildren: () =>
      import('./ui/pages/forms/prospect-to-law-firm-form/routes').then(
        (mod) => mod.routes
      ),
  },

  {
    path: 'ajout-moyen-paiement/:id/:bearer',
    loadChildren: () =>
      import('./ui/pages/forms/payment-method-form/routes').then(
        (mod) => mod.routes
      ),
  },

  {
    path: 'changement-d-offre/:id/:bearer',
    loadChildren: () =>
      import('./ui/pages/forms/new-contract-form/routes').then(
        (mod) => mod.routes
      ),
  },

  {
    path: 'parametrage/:id/:bearer',
    loadChildren: () =>
      import('./ui/pages/forms/on-boarding-form/routes').then(
        (mod) => mod.routes
      ),
  },

  {
    path: 'parametrage-utilisateur/:id/:bearer',
    loadChildren: () =>
      import('./ui/pages/forms/law-firm-user-on-boarding-form/routes').then(
        (mod) => mod.routes
      ),
  },

  {
    path: 'page-introuvable',
    data: {error: 404},
    loadChildren: () =>
      import('./ui/pages/public/error/routes').then((mod) => mod.routes),
  },

  {
    path: 'admin',
    loadChildren: () =>
      import('./ui/pages/admin/dashboard/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          actions: adminActions,
        },
      ],
      flag: 'dashboard',
    },
  },
  {
    path: 'admin/articles',
    loadChildren: () =>
      import('./ui/pages/admin/articles/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Articles', actions: adminArticlesActions},
      ],
      flag: 'articles',
    },
  },
  {
    path: 'admin/articles/edition',
    loadChildren: () =>
      import('./ui/pages/admin/articles-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Articles',
          route: '/admin/articles',
          actions: adminArticlesActions,
        },
        {label: 'Nouvel article'},
      ],
      flag: 'articles',
    },
  },
  {
    path: 'admin/articles/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/articles-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Articles',
          route: '/admin/articles',
          actions: adminArticlesActions,
        },
        {label: 'Edition article #name#'},
      ],
      flag: 'articles',
    },
  },
  {
    path: 'admin/auteurs',
    loadChildren: () =>
      import('./ui/pages/admin/authors/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Auteurs', actions: adminAuthorsActions},
      ],
      flag: 'authors',
    },
  },
  {
    path: 'admin/auteurs/edition',
    loadChildren: () =>
      import('./ui/pages/admin/authors-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Auteurs',
          route: '/admin/auteurs',
          actions: adminAuthorsActions,
        },
        {label: 'Nouvel auteur'},
      ],
      flag: 'authors',
    },
  },
  {
    path: 'admin/auteurs/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/authors-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Auteurs',
          route: '/admin/auteurs',
          actions: adminAuthorsActions,
        },
        {label: 'Edition auteur #name#'},
      ],
      flag: 'authors',
    },
  },
  {
    path: 'admin/avocats',
    loadChildren: () =>
      import('./ui/pages/admin/lawyers/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Avocats'},
      ],
      flag: 'lawyers',
    },
  },
  {
    path: 'admin/clients',
    loadChildren: () =>
      import('./ui/pages/admin/law-firms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition',
    loadChildren: () =>
      import('./ui/pages/admin/law-firms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {label: 'Nouveau client'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/law-firms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          actions: adminLawFirmActions,
        },
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id/utilisateurs',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-users/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          route: '/admin/clients/edition/#id#',
          actions: adminLawFirmActions,
        },
        {label: 'Utilisateurs'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id/contrats',
    loadChildren: () =>
      import('./ui/pages/admin/contracts/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          route: '/admin/clients/edition/#id#',
          actions: adminLawFirmActions,
        },
        {label: 'Utilisateurs'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id/factures',
    loadChildren: () =>
      import('./ui/pages/admin/invoices/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          route: '/admin/clients/edition/#id#',
          actions: adminLawFirmActions,
        },
        {label: 'Factures'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id/transactions',
    loadChildren: () =>
      import('./ui/pages/admin/transactions/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          route: '/admin/clients/edition/#id#',
          actions: adminLawFirmActions,
        },
        {label: 'Transactions'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/clients/edition/:id/formulaires-methode-paiement',
    loadChildren: () =>
      import('./ui/pages/admin/payment-method-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Clients', route: '/admin/clients'},
        {
          label: 'Edition client #name#',
          route: '/admin/clients/edition/#id#',
          actions: adminLawFirmActions,
        },
        {label: 'Formulaires paiement'},
      ],
      flag: 'lawFirms',
    },
  },
  {
    path: 'admin/contrats',
    loadChildren: () =>
      import('./ui/pages/admin/contracts/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Contrats',
          actions: adminContractActions,
        },
      ],
      flag: 'contracts',
    },
  },
  {
    path: 'admin/contrats/edition',
    loadChildren: () =>
      import('./ui/pages/admin/contracts-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Contrats', route: '/admin/contrats'},
        {label: 'Nouveau contrat'},
      ],
      flag: 'contracts',
    },
  },
  {
    path: 'admin/contrats/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/contracts-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Contrats', route: '/admin/contrats'},
        {label: 'Edition contrat #name#'},
      ],
      flag: 'contracts',
    },
  },
  {
    path: 'admin/factures',
    loadChildren: () =>
      import('./ui/pages/admin/invoices/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Factures', actions: adminInvoicesActions},
      ],
      flag: 'invoices',
    },
  },
  {
    path: 'admin/factures/edition',
    loadChildren: () =>
      import('./ui/pages/admin/invoices-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Factures',
          route: '/admin/factures',
          actions: adminInvoicesActions,
        },
        {label: 'Nouvelle facture'},
      ],
      flag: 'invoices',
    },
  },
  {
    path: 'admin/factures/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/invoices-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Factures',
          route: '/admin/factures',
          actions: adminInvoicesActions,
        },
        {label: 'Edition facture #name#'},
      ],
      flag: 'invoices',
    },
  },
  {
    path: 'admin/avoirs',
    loadChildren: () =>
      import('./ui/pages/admin/credits/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Avoirs', actions: adminCreditsActions},
      ],
      flag: 'credits',
    },
  },
  {
    path: 'admin/avoirs/edition',
    loadChildren: () =>
      import('./ui/pages/admin/credits-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Avoirs',
          route: '/admin/avoirs',
          actions: adminCreditsActions,
        },
        {label: 'Nouvel avoir'},
      ],
      flag: 'credits',
    },
  },
  {
    path: 'admin/avoirs/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/credits-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Avoirs',
          route: '/admin/avoirs',
          actions: adminCreditsActions,
        },
        {label: 'Edition avoir {0}'},
      ],
      flag: 'credits',
    },
  },
  {
    path: 'admin/fonctionnalites',
    loadChildren: () =>
      import('./ui/pages/admin/features/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Fonctionnalités', actions: adminFeaturesActions},
      ],
      flag: 'features',
    },
  },
  {
    path: 'admin/fonctionnalites/edition',
    loadChildren: () =>
      import('./ui/pages/admin/features-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Fonctionnalités',
          route: '/admin/fonctionnalites',
          actions: adminFeaturesActions,
        },
        {label: 'Nouvelle fonctionnalité'},
      ],
      flag: 'features',
    },
  },
  {
    path: 'admin/fonctionnalites/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/features-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Fonctionnalités',
          route: '/admin/fonctionnalites',
          actions: adminFeaturesActions,
        },
        {label: 'Edition fonctionnalité #name#'},
      ],
      flag: 'features',
    },
  },

  {
    path: 'admin/cgvs',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-sales/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'CGVs', actions: adminGeneralConditionsOfSalesActions},
      ],
      flag: 'generalConditionsOfSales',
    },
  },
  {
    path: 'admin/cgvs/edition',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-sales-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'CGVs',
          route: '/admin/cgvs',
          actions: adminGeneralConditionsOfSalesActions,
        },
        {label: 'Nouvelles CGV'},
      ],
      flag: 'generalConditionsOfSales',
    },
  },
  {
    path: 'admin/cgvs/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-sales-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'CGVs',
          route: '/admin/cgvs',
          actions: adminGeneralConditionsOfSalesActions,
        },
        {label: 'Edition CGV #name#'},
      ],
      flag: 'generalConditionsOfSales',
    },
  },

  {
    path: 'admin/cgus',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-uses/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'CGUs', actions: adminGeneralConditionsOfUsesActions},
      ],
      flag: 'generalConditionsOfUses',
    },
  },
  {
    path: 'admin/cgus/edition',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-uses-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'CGUs',
          route: '/admin/cgus',
          actions: adminGeneralConditionsOfUsesActions,
        },
        {label: 'Nouvelles CGU'},
      ],
      flag: 'generalConditionsOfUses',
    },
  },
  {
    path: 'admin/cgus/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/general-conditions-of-uses-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'CGUs',
          route: '/admin/cgus',
          actions: adminGeneralConditionsOfUsesActions,
        },
        {label: 'Edition CGU #name#'},
      ],
      flag: 'generalConditionsOfUses',
    },
  },

  {
    path: 'admin/offres',
    loadChildren: () =>
      import('./ui/pages/admin/offers/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Offres', actions: adminOffersActions},
      ],
      flag: 'offers',
    },
  },
  {
    path: 'admin/offres/edition',
    loadChildren: () =>
      import('./ui/pages/admin/offers-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Offres',
          route: '/admin/offres',
          actions: adminOffersActions,
        },
        {label: 'Nouvelle offre'},
      ],
      flag: 'offers',
    },
  },
  {
    path: 'admin/offres/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/offers-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Offres',
          route: '/admin/offres',
          actions: adminOffersActions,
        },
        {label: 'Editon offre #name#'},
      ],
      flag: 'offers',
    },
  },
  {
    path: 'admin/prospects',
    loadChildren: () =>
      import('./ui/pages/admin/prospects/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Prospects'},
      ],
      flag: 'prospects',
    },
  },
  {
    path: 'admin/prospects/edition',
    loadChildren: () =>
      import('./ui/pages/admin/prospects-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Prospects', route: '/admin/prospects'},
        {label: 'Nouveau prospect'},
      ],
      flag: 'prospects',
    },
  },
  {
    path: 'admin/prospects/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/prospects-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Prospects', route: '/admin/prospects'},
        {label: 'Edition prospect #name#'},
      ],
      flag: 'prospects',
    },
  },
  {
    path: 'admin/formulaires-prospects',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-to-law-firm-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires prospects'},
      ],
      flag: 'prospect-to-law-firm-forms',
    },
  },
  {
    path: 'admin/formulaires-prospects/edition',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-to-law-firm-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires prospects', route: '/admin/formulaires-prospects'},
        {label: 'Nouveau formulaire'},
      ],
      flag: 'prospect-to-law-firm-forms',
    },
  },
  {
    path: 'admin/formulaires-prospects/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-to-law-firm-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires prospects', route: '/admin/formulaires-prospects'},
        {label: 'Edition formulaire prospect #name#'},
      ],
      flag: 'prospect-to-law-firm-forms',
    },
  },

  {
    path: 'admin/formulaires-methode-paiement',
    loadChildren: () =>
      import('./ui/pages/admin/payment-method-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires paiement'},
      ],
      flag: 'payment-method-forms',
    },
  },
  {
    path: 'admin/formulaires-methode-paiement/edition',
    loadChildren: () =>
      import('./ui/pages/admin/payment-method-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires paiement', route: '/admin/formulaires-methode-paiement'},
        {label: 'Nouveau formulaire'},
      ],
      flag: 'payment-method-forms',
    },
  },
  {
    path: 'admin/formulaires-methode-paiement/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/payment-method-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires paiement', route: '/admin/formulaires-methode-paiement'},
        {label: 'Edition formulaire paiement #name#'},
      ],
      flag: 'payment-method-forms',
    },
  },

  {
    path: 'admin/formulaires-changement-d-offre',
    loadChildren: () =>
      import('./ui/pages/admin/new-contract-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires changement d\'offre'},
      ],
      flag: 'new-contract-forms',
    },
  },
  {
    path: 'admin/formulaires-changement-d-offre/edition',
    loadChildren: () =>
      import('./ui/pages/admin/new-contract-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires changement d\'offre', route: '/admin/formulaires-changement-d-offre'},
        {label: 'Nouveau formulaire'},
      ],
      flag: 'new-contract-forms',
    },
  },
  {
    path: 'admin/formulaires-changement-d-offre/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/new-contract-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires changement d\'offre', route: '/admin/formulaires-changement-d-offre'},
        {label: 'Edition formulaire changementd\'offre {0}'},
      ],
      flag: 'new-contract-forms',
    },
  },

  {
    path: 'admin/formulaires-onboarding',
    loadChildren: () =>
      import('./ui/pages/admin/on-boarding-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding'},
      ],
      flag: 'on-boarding-forms',
    },
  },
  {
    path: 'admin/formulaires-onboarding/edition',
    loadChildren: () =>
      import('./ui/pages/admin/on-boarding-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding', route: '/admin/formulaires-onboarding'},
        {label: 'Nouveau formulaire'},
      ],
      flag: 'on-boarding-forms',
    },
  },
  {
    path: 'admin/formulaires-onboarding/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/on-boarding-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding', route: '/admin/formulaires-onboarding'},
        {label: 'Edition formulaire d\'onboarding {0}'},
      ],
      flag: 'on-boarding-forms',
    },
  },

  {
    path: 'admin/formulaires-onboarding-utilisateur',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-user-on-boarding-forms/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding utilisateur'},
      ],
      flag: 'law-firm-user-on-boarding-forms',
    },
  },
  {
    path: 'admin/formulaires-onboarding-utilisateur/edition',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-user-on-boarding-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding utilisateur', route: '/admin/formulaires-onboarding-utilisateur'},
        {label: 'Nouveau formulaire'},
      ],
      flag: 'law-firm-user-on-boarding-forms',
    },
  },
  {
    path: 'admin/formulaires-onboarding-utilisateur/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-user-on-boarding-forms-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Formulaires d\'onboarding utilisateur', route: '/admin/formulaires-onboarding-utilisateur'},
        {label: 'Edition formulaire d\'onboarding utilisateur {0}'},
      ],
      flag: 'law-firm-user-on-boarding-forms',
    },
  },

  {
    path: 'admin/roles',
    loadChildren: () =>
      import('./ui/pages/admin/roles/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Rôles', actions: adminRolesActions},
      ],
      flag: 'roles',
    },
  },
  {
    path: 'admin/roles/edition',
    loadChildren: () =>
      import('./ui/pages/admin/roles-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Rôles', route: '/admin/roles', actions: adminRolesActions},
        {label: 'Nouveau rôle'},
      ],
      flag: 'roles',
    },
  },
  {
    path: 'admin/roles/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/roles-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Rôles', route: '/admin/roles', actions: adminRolesActions},
        {label: 'Edition rôle #name#'},
      ],
      flag: 'roles',
    },
  },
  {
    path: 'admin/specialites-juridiques',
    loadChildren: () =>
      import('./ui/pages/admin/legal-practice-areas/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Spécialités juridiques', actions: adminLegalPracticeAreaActions},
      ],
      flag: 'legalPracticeAreas',
    },
  },
  {
    path: 'admin/specialites-juridiques/edition',
    loadChildren: () =>
      import('./ui/pages/admin/legal-practice-areas-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Spécialités juridiques', route: '/admin/specialites-juridiques', actions: adminRolesActions},
        {label: 'Nouvelle spécialité juridique'},
      ],
      flag: 'legalPracticeAreas',
    },
  },
  {
    path: 'admin/specialites-juridiques/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/legal-practice-areas-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Spécialités juridiques', route: '/admin/specialites-juridiques', actions: adminRolesActions},
        {label: 'Edition spécialité #name#'},
      ],
      flag: 'legalPracticeAreas',
    },
  },
  {
    path: 'admin/thematiques-juridiques',
    loadChildren: () =>
      import('./ui/pages/admin/legal-topics/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Thématiques juridiques'},
      ],
      flag: 'legalTopics',
    },
  },
  {
    path: 'admin/thematiques-juridiques/edition',
    loadChildren: () =>
      import('./ui/pages/admin/legal-topics-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Thématiques juridiques', route: '/admin/thematiques-juridiques'},
        {label: 'Nouvelle thématique juridique'},
      ],
      flag: 'legalTopics',
    },
  },
  {
    path: 'admin/thematiques-juridiques/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/legal-topics-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Thématiques juridiques', route: '/admin/thematiques-juridiques'},
        {label: 'Edition thématique #name#'},
      ],
      flag: 'legalTopics',
    },
  },
  {
    path: 'admin/types-d-affaire',
    loadChildren: () =>
      import('./ui/pages/admin/case-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'affaire', actions: adminCaseTypeActions},
      ],
      flag: 'caseTypes',
    },
  },
  {
    path: 'admin/types-d-affaire/edition',
    loadChildren: () =>
      import('./ui/pages/admin/case-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'affaire', route: '/admin/types-d-affaire', actions: adminCaseTypeActions},
        {label: 'Nouveau type d\'affaire'},
      ],
      flag: 'caseTypes',
    },
  },
  {
    path: 'admin/types-d-affaire/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/case-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'affaire', route: '/admin/types-d-affaire', actions: adminCaseTypeActions},
        {label: 'Edition type d\'affaire #name#'},
      ],
      flag: 'caseTypes',
    },
  },
  {
    path: 'admin/instances',
    loadChildren: () =>
      import('./ui/pages/admin/court-levels/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Instances', actions: adminCourtLevelsActions},
      ],
      flag: 'courtLevels',
    },
  },
  {
    path: 'admin/instances/edition',
    loadChildren: () =>
      import('./ui/pages/admin/court-levels-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Instances', route: '/admin/instances', actions: adminCourtLevelsActions},
        {label: 'Nouvelle instance'},
      ],
      flag: 'courtLevels',
    },
  },
  {
    path: 'admin/instances/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/court-levels-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Instances', route: '/admin/instances', actions: adminCourtLevelsActions},
        {label: 'Edition instance #name#'},
      ],
      flag: 'courtLevels',
    },
  },
  {
    path: 'admin/types-de-mission',
    loadChildren: () =>
      import('./ui/pages/admin/engagement-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de mission', actions: adminEngagementTypesActions},
      ],
      flag: 'engagementTypes',
    },
  },
  {
    path: 'admin/types-de-mission/edition',
    loadChildren: () =>
      import('./ui/pages/admin/engagement-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de mission', route: '/admin/types-de-mission', actions: adminEngagementTypesActions},
        {label: 'Nouveau type de mission'},
      ],
      flag: 'engagementTypes',
    },
  },
  {
    path: 'admin/types-de-mission/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/engagement-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de mission', route: '/admin/types-de-mission', actions: adminEngagementTypesActions},
        {label: 'Edition type de mission #name#'},
      ],
      flag: 'engagementTypes',
    },
  },
  {
    path: 'admin/types-de-procedure',
    loadChildren: () =>
      import('./ui/pages/admin/proceeding-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de procédure', actions: adminProceedingTypesActions},
      ],
      flag: 'proceedingTypes',
    },
  },
  {
    path: 'admin/types-de-procedure/edition',
    loadChildren: () =>
      import('./ui/pages/admin/proceeding-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de procédure', route: '/admin/types-de-procedure', actions: adminProceedingTypesActions},
        {label: 'Nouveau type de procédure'},
      ],
      flag: 'proceedingTypes',
    },
  },
  {
    path: 'admin/types-de-procedure/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/proceeding-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de procédure', route: '/admin/types-de-procedure', actions: adminProceedingTypesActions},
        {label: 'Edition type de procédure #name#'},
      ],
      flag: 'proceedingTypes',
    },
  },
  {
    path: 'admin/types-de-responsable-dossier',
    loadChildren: () =>
      import('./ui/pages/admin/case-owner-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de responsable dossier', actions: adminCaseOwnerTypesActions},
      ],
      flag: 'caseOwnerTypes',
    },
  },
  {
    path: 'admin/types-de-responsable-dossier/edition',
    loadChildren: () =>
      import('./ui/pages/admin/case-owner-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de responsable dossier', route: '/admin/types-de-responsable-dossier', actions: adminCaseOwnerTypesActions},
        {label: 'Nouveau type de responsable dossier'},
      ],
      flag: 'caseOwnerTypes',
    },
  },
  {
    path: 'admin/types-de-responsable-dossier/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/case-owner-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de responsable dossier', route: '/admin/types-de-responsable-dossier', actions: adminCaseOwnerTypesActions},
        {label: 'Edition type de responsable dossier #name#'},
      ],
      flag: 'caseOwnerTypes',
    },
  },
  {
    path: 'admin/types-d-avocat-en-charge',
    loadChildren: () =>
      import('./ui/pages/admin/attorney-in-charge-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'avocat en charge', actions: adminAttorneyInChargeTypesActions},
      ],
      flag: 'attorneyInChargeTypes',
    },
  },
  {
    path: 'admin/types-d-avocat-en-charge/edition',
    loadChildren: () =>
      import('./ui/pages/admin/attorney-in-charge-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'avocat en charge', route: '/admin/types-d-avocat-en-charge', actions: adminAttorneyInChargeTypesActions},
        {label: 'Nouveau type d\'avocat en charge'},
      ],
      flag: 'attorneyInChargeTypes',
    },
  },
  {
    path: 'admin/types-d-avocat-en-charge/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/attorney-in-charge-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types d\'avocat en charge', route: '/admin/types-d-avocat-en-charge', actions: adminAttorneyInChargeTypesActions},
        {label: 'Edition type d\'avocat en charge #name#'},
      ],
      flag: 'attorneyInChargeTypes',
    },
  },
  {
    path: 'admin/utilisations-liste-documents',
    loadChildren: () =>
      import('./ui/pages/admin/document-list-usages/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Utilisations liste documents', actions: adminDocumentListUsagesActions},
      ],
      flag: 'documentListUsages',
    },
  },
  {
    path: 'admin/utilisations-liste-documents/edition',
    loadChildren: () =>
      import('./ui/pages/admin/document-list-usages-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Utilisations liste documents', route: '/admin/utilisations-liste-documents', actions: adminDocumentListUsagesActions},
        {label: 'Nouvelle utilisation liste documents'},
      ],
      flag: 'documentListUsages',
    },
  },
  {
    path: 'admin/utilisations-liste-documents/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/document-list-usages-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Utilisations liste documents', route: '/admin/utilisations-liste-documents', actions: adminDocumentListUsagesActions},
        {label: 'Edition utilisation liste documents #name#'},
      ],
      flag: 'documentListUsages',
    },
  },
  {
    path: 'admin/nommages-documents',
    loadChildren: () =>
      import('./ui/pages/admin/document-name-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Nommages documents', actions: adminDocumentNameTypesActions},
      ],
      flag: 'documentNameTypes',
    },
  },
  {
    path: 'admin/nommages-documents/edition',
    loadChildren: () =>
      import('./ui/pages/admin/document-name-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Nommages documents', route: '/admin/nommages-documents', actions: adminDocumentNameTypesActions},
        {label: 'Nouveau nommage de document'},
      ],
      flag: 'documentNameTypes',
    },
  },
  {
    path: 'admin/nommages-documents/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/document-name-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Nommages documents', route: '/admin/nommages-documents', actions: adminDocumentNameTypesActions},
        {label: 'Edition nommage de document #name#'},
      ],
      flag: 'documentNameTypes',
    },
  },
  {
    path: 'admin/types-de-suivi-de-temps',
    loadChildren: () =>
      import('./ui/pages/admin/time-tracking-types/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de suivi de temps', actions: adminTimeTrackingTypeActions},
      ],
      flag: 'timeTrackingTypes',
    },
  },
  {
    path: 'admin/types-de-suivi-de-temps/edition',
    loadChildren: () =>
      import('./ui/pages/admin/time-tracking-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de suivi de temps', route: '/admin/types-de-suivi-de-temps', actions: adminTimeTrackingTypeActions},
        {label: 'Nouveau type de suivi de temps'},
      ],
      flag: 'timeTrackingTypes',
    },
  },
  {
    path: 'admin/types-de-suivi-de-temps/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/time-tracking-types-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Types de suivi de temps', route: '/admin/types-de-suivi-de-temps', actions: adminTimeTrackingTypeActions},
        {label: 'Edition type de suivi de temps #name#'},
      ],
      flag: 'timeTrackingTypes',
    },
  },
  {
    path: 'admin/parametres',
    loadChildren: () =>
      import('./ui/pages/admin/settings/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Paramètres', actions: adminSettingsActions},
      ],
      flag: 'settings',
    },
  },
  {
    path: 'admin/parametres/edition',
    loadChildren: () =>
      import('./ui/pages/admin/settings-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Paramètres',
          route: '/admin/parametres',
          actions: adminSettingsActions,
        },
        {label: 'Nouveau paramètre'},
      ],
      flag: 'settings',
    },
  },
  {
    path: 'admin/parametres/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/settings-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Paramètres',
          route: '/admin/parametres',
          actions: adminSettingsActions,
        },
        {label: 'Edition paramètres #name#'},
      ],
      flag: 'settings',
    },
  },

  {
    path: 'admin/option-quotas',
    loadChildren: () =>
      import('./ui/pages/admin/quota-options/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Options de quota', actions: adminQuotaOptionsActions},
      ],
      flag: 'quotaOptions',
    },
  },
  {
    path: 'admin/option-quotas/edition',
    loadChildren: () =>
      import('./ui/pages/admin/quota-options-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Options de quota', route: '/admin/option-quotas', actions: adminQuotaOptionsActions},
        {label: 'Nouvelle option de quota'},
      ],
      flag: 'quotaOptions',
    },
  },
  {
    path: 'admin/option-quotas/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/quota-options-edition/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Options de quota', route: '/admin/option-quotas', actions: adminQuotaOptionsActions},
        {label: 'Edition option de quota #name#'},
      ],
      flag: 'quotaOptions',
    },
  },
  {
    path: 'admin/statuts-prospect',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-statuses/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Statuts prospect', actions: adminProspectStatusesActions},
      ],
      flag: 'prospectStatuses',
    },
  },
  {
    path: 'admin/statuts-prospect/edition',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-statuses-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Statuts prospect',
          route: '/admin/statuts-prospect',
          actions: adminProspectStatusesActions,
        },
        {label: 'Nouveau statut prospect'},
      ],
      flag: 'prospectStatuses',
    },
  },
  {
    path: 'admin/statuts-prospect/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/prospect-statuses-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Statuts prospect',
          route: '/admin/statuts-prospect',
          actions: adminProspectStatusesActions,
        },
        {label: 'Edition statut prospect #name#'},
      ],
      flag: 'prospectStatuses',
    },
  },
  {
    path: 'admin/templates-email',
    loadChildren: () =>
      import('./ui/pages/admin/email-templates/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Templates email', actions: adminEmailTemplatesActions},
      ],
      flag: 'emailTemplates',
    },
  },
  {
    path: 'admin/templates-email/edition',
    loadChildren: () =>
      import('./ui/pages/admin/email-templates-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Templates email',
          route: '/admin/templates-email',
          actions: adminEmailTemplatesActions,
        },
        {label: 'Nouveau template email'},
      ],
      flag: 'emailTemplates',
    },
  },
  {
    path: 'admin/templates-email/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/email-templates-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Templates email',
          route: '/admin/templates-email',
          actions: adminEmailTemplatesActions,
        },
        {label: 'Edition template email #name#'},
      ],
      flag: 'emailTemplates',
    },
  },
  {
    path: 'admin/topics',
    loadChildren: () =>
      import('./ui/pages/admin/topics/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Topics', actions: adminTopicsActions},
      ],
      flag: 'topics',
    },
  },
  {
    path: 'admin/topics/edition',
    loadChildren: () =>
      import('./ui/pages/admin/topics-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Topics',
          route: '/admin/topics',
          actions: adminTopicsActions,
        },
        {label: 'Nouveau topic'},
      ],
      flag: 'topics',
    },
  },
  {
    path: 'admin/topics/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/topics-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Topics',
          route: '/admin/topics',
          actions: adminTopicsActions,
        },
        {label: 'Edition topic #name#'},
      ],
      flag: 'topics',
    },
  },
  {
    path: 'admin/transactions',
    loadChildren: () =>
      import('./ui/pages/admin/transactions/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Transactions'},
      ],
      flag: 'transactions',
    },
  },
  {
    path: 'admin/transactions/edition',
    loadChildren: () =>
      import('./ui/pages/admin/transactions-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Transactions', route: '/admin/transactions'},
        {label: 'Nouvelle transaction'},
      ],
      flag: 'transactions',
    },
  },
  {
    path: 'admin/transactions/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/transactions-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Transactions', route: '/admin/transactions'},
        {label: 'Edition transaction #name#'},
      ],
      flag: 'transactions',
    },
  },
  {
    path: 'admin/types-interaction-prospect',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-prospect-types/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: "Types d'interaction prospect", actions: adminInteractionProspectTypesActions},
      ],
      flag: 'interactionProspectTypes',
    },
  },
  {
    path: 'admin/types-interaction-prospect/edition',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-prospect-types-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: "Types d'interaction prospect",
          route: '/admin/types-interaction-prospect',
          actions: adminInteractionProspectTypesActions,
        },
        {label: "Nouveau types d'interaction prospect"},
      ],
      flag: 'interactionProspectTypes',
    },
  },
  {
    path: 'admin/types-interaction-prospect/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-prospect-types-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: "Types d'interaction prospect",
          route: '/admin/types-interaction-prospect',
          actions: adminInteractionProspectTypesActions,
        },
        {label: "Edition type d'interaction prospect #name#"},
      ],
      flag: 'interactionProspectTypes',
    },
  },

  {
    path: 'admin/types-interaction-client',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-law-firm-types/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: "Types d'interaction client", actions: adminInteractionLawFirmTypesActions},
      ],
      flag: 'interactionLawFirmTypes',
    },
  },
  {
    path: 'admin/types-interaction-client/edition',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-law-firm-types-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: "Types d'interaction client",
          route: '/admin/types-interaction-client',
          actions: adminInteractionLawFirmTypesActions,
        },
        {label: "Nouveau types d'interaction client"},
      ],
      flag: 'interactionLawFirmTypes',
    },
  },
  {
    path: 'admin/types-interaction-client/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/interaction-law-firm-types-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: "Types d'interaction client",
          route: '/admin/types-interaction-client',
          actions: adminInteractionProspectTypesActions,
        },
        {label: "Edition type d'interaction client #name#"},
      ],
      flag: 'interactionLawFirmTypes',
    },
  },

  {
    path: 'admin/utilisateurs',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-users/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Utilisateurs', actions: adminLawFirmUsersActions},
      ],
      flag: 'lawFirmUsers',
    },
  },
  {
    path: 'admin/utilisateurs/edition',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-users-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Utilisateurs',
          route: '/admin/utilisateurs',
          actions: adminLawFirmUsersActions,
        },
        {label: 'Nouvel utilisateur'},
      ],
      flag: 'lawFirmUsers',
    },
  },
  {
    path: 'admin/utilisateurs/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/law-firm-users-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Utilisateurs',
          route: '/admin/utilisateurs',
          actions: adminLawFirmUsersActions,
        },
        {label: 'Edition utilisateur #name#'},
      ],
      flag: 'lawFirmUsers',
    },
  },
  {
    path: 'admin/vehicules',
    loadChildren: () =>
      import('./ui/pages/admin/vehicles/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Véhicules', actions: adminVehiclesActions},
      ],
      flag: 'vehicles',
    },
  },
  {
    path: 'admin/vehicules/edition',
    loadChildren: () =>
      import('./ui/pages/admin/vehicles-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Véhicules',
          route: '/admin/vehicules',
          actions: adminVehiclesActions,
        },
        {label: 'Nouveau véhicule'},
      ],
      flag: 'vehicles',
    },
  },
  {
    path: 'admin/vehicules/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/vehicles-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Véhicules',
          route: '/admin/vehicules',
          actions: adminVehiclesActions,
        },
        {label: 'Edition véhicule #name#'},
      ],
      flag: 'vehicles',
    },
  },
  {
    path: 'admin/workflows-email',
    loadChildren: () =>
      import('./ui/pages/admin/email-workflows/routes').then((mod) => mod.routes),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {label: 'Workflows email', actions: adminEmailWorkflowsActions},
      ],
      flag: 'emailWorkflows',
    },
  },
  {
    path: 'admin/workflows-email/edition',
    loadChildren: () =>
      import('./ui/pages/admin/email-workflows-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Workflows email',
          route: '/admin/workflows-email',
          actions: adminEmailWorkflowsActions,
        },
        {label: 'Nouveau workflow email'},
      ],
      flag: 'emailWorkflows',
    },
  },
  {
    path: 'admin/workflows-email/edition/:id',
    loadChildren: () =>
      import('./ui/pages/admin/email-workflows-edition/routes').then(
        (mod) => mod.routes
      ),
    canActivate: [MsalGuard],
    data: {
      breadcrumbItems: [
        {
          label: 'Dashboard',
          route: '/admin',
          actions: adminActions,
        },
        {
          label: 'Workflows email',
          route: '/admin/workflows-email',
          actions: adminEmailWorkflowsActions,
        },
        {label: 'Edition workflow email #name#'},
      ],
      flag: 'emailWorkflows',
    },
  },

  {path: '**', redirectTo: 'page-introuvable'},
];
